import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.component, {
    tag: "component",
    staticClass: "v-badge",
    class: _vm.classes,
    style: _vm.styles
  }, [_c('div', {
    staticClass: "v-badge__wrapper"
  }, [_vm._t("default"), _vm._v(" "), _c('span', _vm._g(_vm._b({
    staticClass: "v-badge__badge"
  }, 'span', _vm.$attrs, false), _vm.$listeners), [!_vm.dot ? [_vm._t("content", function () {
    return [_vm._v("\n          " + _vm._s(_vm.content) + "\n        ")];
  })] : _vm._e()], 2)], 2)]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-d6ed3adc_0", {
    source: ".v-badge[data-v-d6ed3adc]{display:inline-block;line-height:1}.v-badge--attached .v-badge__badge[data-v-d6ed3adc],.v-badge--floating .v-badge__badge[data-v-d6ed3adc]{position:absolute}.v-badge--floating .v-badge__badge[data-v-d6ed3adc]{bottom:calc(100% - 4px);left:calc(100% - 4px)}.v-badge--floating.v-badge--dot .v-badge__badge[data-v-d6ed3adc]{bottom:calc(100% - 2px);left:calc(100% - 2px)}.v-badge--attached .v-badge__badge[data-v-d6ed3adc]{bottom:calc(100% - 12px);left:calc(100% - 12px)}.v-badge--attached.v-badge--dot .v-badge__badge[data-v-d6ed3adc]{bottom:calc(100% - 8px);left:calc(100% - 8px)}.v-badge--dot .v-badge__badge[data-v-d6ed3adc]{border-radius:4.5px;height:9px;min-width:0;padding:0;width:9px}.v-badge__wrapper[data-v-d6ed3adc]{display:flex;position:relative}.v-badge__badge[data-v-d6ed3adc]{background-color:var(--c-bg-color);color:var(--c-color);color-adjust:exact;-webkit-print-color-adjust:exact;display:inline-flex;border-radius:10px;height:1.25rem;min-width:20px;padding:4px 6px;font-family:var(--g-font-body-family);font-size:.75rem;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-d6ed3adc";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var Badge = __vue_component__;
export { Badge as default };